import PropTypes from 'prop-types';
import { SubmitButton } from '../../../../shared';

function ReferralsProductionListModalFormSubmit({
  isSubmitting,
  isValid,
  isLoading,
  loading,
  handleSubmit,
}) {
  return (
    <div className="col-span-full mt-4 flex items-center justify-end gap-x-4">
      <SubmitButton
        isLoading={isLoading || loading}
        isSubmitting={isSubmitting}
        isValid={isValid}
        label="Update Case Details"
        full
        notRounded
      />
    </div>
  );
}

ReferralsProductionListModalFormSubmit.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default ReferralsProductionListModalFormSubmit;
